/**
 * Convertes entry filter params into searchUrl
 *
 * @param entry, type, from, limit
 * @returns {url}
 */
export default function getRelatedSearchUrl(entry, from, limit, site, type) {
  if (!entry) return null
  const searchApiUrl = process.env.NEXT_PUBLIC_ELASTICSEARCH_API
  const searchType = type
  const searchParams = new URLSearchParams()

  if (type === 'trainings') {
    const exerciseData = entry.exercises ? entry.exercises : entry
    const exercises = exerciseData.constructor.name === 'Array' ? { ...exerciseData } : exerciseData
    const ageCategories = []
    for (const key in exercises) {
      exercises[key].ageCategories.forEach((ageGroup) => {
        ageCategories.push(ageGroup)
      })
    }

    const ageCategoriesArray = Array.from(new Set(ageCategories.map(JSON.stringify))).map(JSON.parse)
    ageCategoriesArray.forEach((o) => {
      if (o?.level >= 2) searchParams.append('ageCategories[]', o.id)
    })
  } else if (type === 'exercises') {
    const fieldType = entry?.exerciseContent?.[0]?.fieldTypeCategory?.[0] || false
    if (fieldType) searchParams.append('fieldTypeCategory[]', fieldType.id)
    const filteredAgeCategories = entry.ageCategories.filter((category) => {
      return category.level === 2
    })
    const sortedAgeategories = filteredAgeCategories.sort()
    sortedAgeategories.forEach((o) => {
      if (o?.level >= 2) searchParams.append('ageCategories[]', o.id)
    })
  } else if (type === 'programs') {
    const entryTrainings = entry?.trainings?.length ? entry.trainings : entry.userTrainingsAndTrainings
    const ageCategories = []

    for (const tKey in entryTrainings) {
      for (const eKey in entryTrainings[tKey].exercises) {
        entryTrainings[tKey].exercises[eKey].ageCategories.forEach((ageGroup) => {
          ageCategories.push(ageGroup)
        })
      }
    }

    const ageCategoriesArray = Array.from(new Set(ageCategories.map(JSON.stringify))).map(JSON.parse)
    ageCategoriesArray.forEach((o) => {
      if (o?.level >= 2) searchParams.append('ageCategories[]', o.id)
    })
  }

  searchParams.append('from', from)
  searchParams.append('limit', limit)
  searchParams.append('site', site)

  const searchResultsQuery = searchParams.toString().length ? `?${searchParams.toString()}` : ''
  const searchUrl = `${searchApiUrl}/${searchType}/search${searchResultsQuery}`

  return searchUrl
}
